import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class NotificationType extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "excerpt_key", Model.attribute('excerpt_key'));
    _defineProperty(this, "default_url", Model.attribute('default_url'));
    _defineProperty(this, "default_icon", Model.attribute('default_icon', 'fas fa-bell'));
    _defineProperty(this, "default_message_key", Model.attribute('default_message_key'));
    _defineProperty(this, "is_active", Model.attribute('is_active'));
    _defineProperty(this, "sort_order", Model.attribute('sort_order'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
}
flarum.reg.add('huseyinfiliz-notificationhub', 'forum/models/NotificationType', NotificationType);